import { Tab } from '@mui/material';
import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { QueryTabPanel, QueryTabs } from 'components';
import { AppConfigArea } from 'enums';
import { useMeta, useQueryTab } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { ConfigsPage } from './ConfigsPage';
import { PayinOrderAutomationTab } from './PayinOrderAutomationTab';
import { PayinOrdersTab } from './PayinOrdersTab';
import { PayinP2PProvidersTab } from './PayinP2PProvidersTab';
import { PayinRequisitesTab } from './PayinRequisitesTab';

export enum Tabs {
  Requisites = 'requisites',
  P2PProviders = 'p2p_providers',
  Automation = 'automation',
  Orders = 'orders',
}

const TAB_AREAS: Record<Tabs, AppConfigArea> = {
  [Tabs.Requisites]: AppConfigArea.PayinRequisites,
  [Tabs.P2PProviders]: AppConfigArea.PayinP2PProvider,
  [Tabs.Automation]: AppConfigArea.PayinOrderAutomation,
  [Tabs.Orders]: AppConfigArea.PayinOrders,
};

export const PayinConfigsPage: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });

  const { tab } = useQueryTab();
  const area = useMemo(() => TAB_AREAS[tab as Tabs], [tab]);

  const { ordersMonitoringEnabled } = useMeta();

  return (
    <ConfigsPage area={area}>
      <Fragment>
        <QueryTabs tabsEnum={Tabs}>
          <Tab value={Tabs.Requisites} label={t('tabs.requisites')} />
          <Tab value={Tabs.Automation} label={t('tabs.automation')} />
          <Tab value={Tabs.P2PProviders} label={t('tabs.p2p_providers')} />
          {ordersMonitoringEnabled && (
            <Tab value={Tabs.Orders} label={t('tabs.orders')} />
          )}
        </QueryTabs>
        <QueryTabPanel value={Tabs.Requisites}>
          <PayinRequisitesTab />
        </QueryTabPanel>
        <QueryTabPanel value={Tabs.Automation}>
          <PayinOrderAutomationTab />
        </QueryTabPanel>
        <QueryTabPanel value={Tabs.P2PProviders}>
          <PayinP2PProvidersTab />
        </QueryTabPanel>
        {ordersMonitoringEnabled && (
          <QueryTabPanel value={Tabs.Orders}>
            <PayinOrdersTab />
          </QueryTabPanel>
        )}
      </Fragment>
    </ConfigsPage>
  );
};
